import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import posthog from 'posthog-js';
import * as Sentry from '@sentry/react';

// ── PostHog ───────────────────────────────────────────────────────────────────
if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    loaded: (posthog) => {
      if (process.env.NODE_ENV === 'development') posthog.debug();
    }
  });
}

// ── Sentry frontend (production only) ────────────────────────────────────────
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ba2582240962ba12fc4487ef0e0c5f83e04511383790878720.ingest.us.sentry.io/4511383803789312',
    tracesSampleRate: 0.2,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
